<template>
    <swiper
        :options="swiperOptions"
        :auto-update="true"
        :auto-destroy="true"
        @slideChange="$emit('slideChange')"
        ref="swiper"
        class="taplink-swiper"
    >
        <slot></slot>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
    name: "TaplinkSwiper",
    components: {
        Swiper
    },
    props: {
        updated: {},
        hasPagination: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            swiperOptions: {
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                watchOverflow: true,
                slideToClickedSlide: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            }
        };
    }
};
</script>

<style lang="scss">
.taplink-swiper.swiper-container {
    padding-bottom: 0;
    &-wrapper {
        height: 100% !important;
    }
    .swiper-pagination-bullet {
        width: 10px !important;
        height: 10px !important;
        background-color: rgba(#53a3e0, 0.3) !important;
        &-active {
            background-color: #53a3e0 !important;
        }
    }
}
</style>
